import Vue from "vue";
import Router from "vue-router";
import api from '@/services/api';

import Erro from "../pages/web_cliente/Erro";
// import Erro2 from '../pages/adesao/Erro'

import Home from "../components/views/Home";
import Candidatos from "../pages/web_cliente/candidatos/Candidatos";
import CandidatoConsultar from "../pages/web_cliente/candidatos/consultar/Consultar";
import Avaliar from "../pages/web_cliente/candidatos/avaliar/Avaliacao";
import CancelamentoAdesao from "../pages/web_cliente/CancelamentoAdesao";

import Login from "../pages/web_cliente/auth/Login";
import NovaSenha from "../pages/web_cliente/auth/NovaSenha";
import AlterarSenha from "../pages/web_cliente/auth/AlterarSenha";
import Dashboard from "../pages/web_cliente/Dashboard";
import Perfil from "../pages/web_cliente/Perfil";
import PainelAdmin from "../pages/web_cliente/painelAdmin/PainelAdmin";
import Cobranca from "../pages/web_cliente/cobranca/Cobranca";

// Adesão
//--------------------------------------------------------
import PreCadastro from "../pages/adesao/pre_cadastro/PreCadastro";
import Documentacao from "../pages/adesao/documentacao/Documentacao";
import Msg from "../pages/adesao/Msg";
import Tracking from "../pages/adesao/tracking/Tracking.vue";
//--------------------------------------------------------

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: Home,
      meta: {
        requiresAuth: true, //<--SÓ VAI ACESSAR SE ESTIVER LOGADO, E UMA ROTA PROTEGIDA
      },
    },

    {
      path: "/perfil/:userid",
      component: Perfil,
      props: true, //<--PARA PODE RECEBER O ID ATRAVEZ DAS PROPRIEDADE, PASSO OO PROPS TRUE
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: "/login",
      component: Login,
    },

    {
      path: "/nova-senha",
      component: NovaSenha,
    },

    {
      path: "/alterar-senha",
      component: AlterarSenha,
    },

    {
      path: "/dashboard",
      name: "Dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: "/painelAdmin",
      name: "PainelAdministrativo",
      component: PainelAdmin,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: "/cobranca",
      name: "Cobranca",
      component: Cobranca,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: "/candidatos",
      name: "Candidatos",
      component: Candidatos,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: "/candidato/consultar",
      name: "CandidatoConsultar",
      component: CandidatoConsultar,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: "/candidato/avaliar",
      name: "Avaliar",
      component: Avaliar,
      meta: {
        requiresAuth: true,
      },
    },

    //erro 404
    {
      path: "*",
      component: Erro,
    },

    // Adesão
    //---------------------------------------------------------
    {
      path: "/adesao/erro",
      component: Erro,
    },

    {
      path: "/adesao/pre-cadastro",
      component: PreCadastro,
      name: "emp",
    },

    {
      path: "/adesao/documentacao",
      component: Documentacao,
    },

    {
      path: "/msg",
      component: Msg,
    },

    {
      path: "/adesao/cancelar",
      component: CancelamentoAdesao,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/adesao/tracking",
      component: Tracking,
      meta: { requiresAuth: false },
    },
    //---------------------------------------------------------
  ],
});

router.beforeEach(async (to, _from, next) => {
  // 1. Aguarda app e store estarem disponíveis
  if (!router.app || !router.app.$store) {
    await new Promise(resolve => {
      const checkApp = setInterval(() => {
        if (router.app && router.app.$store) {
          clearInterval(checkApp)
          resolve()
        }
      }, 10)
    })
  }

  // 2. Aguarda store estar pronto (evita race condition)
  if (!router.app.$store.state.isStoreReady) {
    await new Promise(resolve => {
      const checkStore = setInterval(() => {
        if (router.app.$store.state.isStoreReady) {
          clearInterval(checkStore)
          resolve()
        }
      }, 10)
    })
  }

  // ========================================
  // VERIFICAÇÃO DE REDIRECIONAMENTO (Sistema Novo)
  // ========================================
  // Verifica se empresa usa sistema novo ANTES de qualquer outra lógica

  // 1. Pré-cadastro: verifica pela URL (emp=XXX)
  if (to.path === '/adesao/pre-cadastro' && to.query.emp) {
    try {
      const response = await api.get('/adesao/check-redirect', {
        params: { emp: to.query.emp }
      })

      // Se empresa usa sistema novo, redirecionar
      if (response.data.redirect) {
        console.log('🔄 Redirecionando para sistema novo:', response.data.url)
        window.location.href = response.data.url
        return  // Previne navegação no sistema antigo
      }
    } catch (error) {
      console.error('⚠️ Erro ao verificar redirecionamento:', error)
      // Em caso de erro, continua no sistema antigo (fallback seguro)
    }
  }

  // 2. Rotas autenticadas: verifica pela empresa selecionada no Vuex
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const empresaSelecionada = router.app.$store.state.empresaSelecionada

  // ✅ CORREÇÃO: Consultar banco SEMPRE (independente do cache)
  if (requiresAuth && empresaSelecionada) {
    try {
      // Verificar flag REAL no banco de dados (fonte de verdade)
      const response = await api.get(`/web-cliente/empresa/${empresaSelecionada.id}/usa-sistema-novo`)
      const usaSistemaNovoReal = response.data.usaSistemaNovo
      const configVersion = response.data.configVersion

      // Detectar config desatualizada e re-fetch silencioso
      if (configVersion && configVersion !== empresaSelecionada.config_version) {
        try {
          await router.app.$store.dispatch('reloadEmpresaConfig', empresaSelecionada.id)
          console.log('[CONFIG] Empresa config atualizada. v' + empresaSelecionada.config_version + ' → v' + configVersion)
        } catch (e) {
          console.warn('[CONFIG] Falha no re-fetch, seguindo com cache:', e.message)
        }
      }

      // Atualizar store se flag mudou (em qualquer direção)
      if (usaSistemaNovoReal !== empresaSelecionada.usaSistemaNovo) {
        console.log('🔄 Flag mudou no banco:', empresaSelecionada.usaSistemaNovo, '→', usaSistemaNovoReal)
        empresaSelecionada.usaSistemaNovo = usaSistemaNovoReal
        router.app.$store.commit('setEmpresaSelecionada', empresaSelecionada)
      }

      // Se flag está ativa, redirecionar para sistema novo
      if (usaSistemaNovoReal) {
        const urlSistemaNovo = 'https://saascontrateiwebcliente-homologacao.up.railway.app'

        // 🔒 SEGURANÇA: Limpar empresa do localStorage antes de redirecionar
        // Sistema novo validará permissões ao restaurar empresa (não confia no cache)
        localStorage.removeItem('empresaSelecionada')
        console.log('🔒 Cache de empresa limpo (sistema novo validará permissões)')

        // Preservar query params na URL de redirecionamento
        const queryString = Object.keys(to.query).length > 0
          ? '?' + new URLSearchParams(to.query).toString()
          : ''
        const newUrl = `${urlSistemaNovo}${to.path}${queryString}`

        console.log('🔄 Empresa migrada! Redirecionando para sistema novo:', newUrl)
        window.location.href = newUrl
        return  // Previne navegação no sistema antigo
      }
    } catch (error) {
      console.error('⚠️ Erro ao verificar usaSistemaNovo no banco:', error)
      // Fallback: se tinha flag true no cache E deu erro, redireciona
      if (empresaSelecionada.usaSistemaNovo) {
        const urlSistemaNovo = 'https://saascontrateiwebcliente-homologacao.up.railway.app'

        // 🔒 SEGURANÇA: Limpar cache também no fallback
        localStorage.removeItem('empresaSelecionada')
        console.log('🔒 Cache de empresa limpo (fallback - sistema novo validará)')

        const queryString = Object.keys(to.query).length > 0
          ? '?' + new URLSearchParams(to.query).toString()
          : ''
        const newUrl = `${urlSistemaNovo}${to.path}${queryString}`
        console.log('🔄 Redirecionando (fallback por erro):', newUrl)
        window.location.href = newUrl
        return
      }
      // Se tinha false no cache e deu erro, continua no sistema antigo (seguro)
    }
  }

  // 3. ÚNICA fonte de verdade para decisões de navegação
  const hasUser = router.app.$store.state.auth.user !== null
  const hasEmpresa = router.app.$store.state.empresaSelecionada !== null

  // Autenticação completa = usuário logado E empresa selecionada
  const isFullyAuthenticated = hasUser && hasEmpresa

  // 4. Lógica de redirecionamento
  if (requiresAuth && !isFullyAuthenticated) {
    // Não está completamente logado e rota requer autenticação -> vai pro login
    next('/login')
  } else if ((to.path === '/login' || to.path === '/') && isFullyAuthenticated) {
    // Está completamente logado e tentando acessar login ou home -> vai pra /candidatos
    next('/candidatos')
  } else {
    // Deixa passar
    next()
  }
});

/* AGORA VOU EM (MAIN.JS) PARA VERIFICAR SE TEM USUÁRIO LOGADO */

export default router;
